import { createContext, useContext, useState, useCallback } from 'react';

// Tiny global error sink. Any component can `useError().show("…")` to surface
// a banner; it auto-dismisses after 6s or on next call.

const ErrorCtx = createContext({ show: () => {}, clear: () => {} });

let setterRef = null; // bridge for non-hook callers (rare)

export function ErrorProvider({ children }) {
  const [msg, setMsg] = useState(null);
  const show = useCallback((m) => {
    setMsg(m);
    if (m) setTimeout(() => setMsg(prev => prev === m ? null : prev), 6000);
  }, []);
  setterRef = show;
  return (
    <ErrorCtx.Provider value={{ show, clear: () => setMsg(null), msg }}>
      {children}
    </ErrorCtx.Provider>
  );
}

export function useError() {
  return useContext(ErrorCtx);
}

// Default export = the banner UI. Mounted once in RootLayout via the provider.
export default function ErrorBanner() {
  return (
    <ErrorProvider>
      <BannerView />
    </ErrorProvider>
  );
}

function BannerView() {
  const { msg, clear } = useContext(ErrorCtx);
  if (!msg) return null;
  return (
    <div className="banner error" role="alert" style={{
      position: 'fixed', top: 12, left: '50%', transform: 'translateX(-50%)',
      zIndex: 2000, maxWidth: 720, width: 'calc(100% - 24px)',
      cursor: 'pointer',
    }} onClick={clear}>
      {msg}
    </div>
  );
}
